import React from "react";
import "./error404.css";
import { Link } from "react-router-dom";
import fourzerofour from '../../assets/404.png'
import fouronefourleft from '../../assets/404left.png';
import fouronefourright from '../../assets/404right.png';
export const ErrorPage = () => {
  return (
    <>
    <img className="fourzerofour-left" src={fouronefourleft} ></img>
    <img className="fourzerofour-right" src={fouronefourright} ></img>
      <div className="container-error">
        <img className="404" src={fourzerofour} />
        <h3 style={{color: "black"}}>WHOOPS..!</h3>
        <p style={{color: "black"}}>Looks like this page went to other universe</p>
        <Link to="/" className="error-homepage"><button style={{color: "white "}}>GO TO HOME PAGE</button></Link>

      </div>
    </>
  )
}
